module.exports = __webpack_public_path__ + "img/tzfardea_yes.801aba1a.png";